import { Icon } from '@design/components/icon/Icon';
import { SvgIconNames } from '@design/design-tokens/iconography/SvgIcons';

export interface RegionIconProps {
  region: string;
  size?: number;
  viewBox?: string;
  fillColor?: string;
}

const mapRegionToIcon = (regionRaw: string): SvgIconNames => {
  const region = regionRaw.toLowerCase();

  if (/(North america|south america)/i.test(region)) {
    return 'EarthAmerica';
  }

  if (/(europe)/i.test(region)) {
    return 'EarthEurope';
  }

  if (/^eu$/i.test(region)) {
    return 'EarthEU';
  }

  if (/(africa)/i.test(region)) {
    return 'EarthAfrica';
  }

  if (/(australia)/i.test(region)) {
    return 'EarthAustralia';
  }

  if (/(asia|korea|japan)/i.test(region)) {
    return 'EarthAsia';
  }

  return 'EarthOthers';
};

export const RegionIcon = ({
  region,
  size = 32,
  fillColor = 'var(--icon-default)',
  viewBox = '0 0 32 32',
}: RegionIconProps) => {
  const iconName = mapRegionToIcon(region);
  return (
    <Icon
      iconName={iconName}
      size={size}
      fillColor={fillColor}
      viewBox={viewBox}
    />
  );
};
